import { Component } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import {
  GridHeader,
  GridRowData,
} from '@marketing/subscriptions-manage/subscription-manage.interface';
import { SubscriptionProductsService } from '@marketing/subscriptions-manage/services/subscription-products.service';

@Component({
  selector: 'ft-documents-cell-renderer',
  templateUrl: './documents-cell-renderer.component.html',
  styleUrls: ['./documents-cell-renderer.component.scss'],
})
export class DocumentsCellRendererComponent
  implements ICellRendererAngularComp {
  public params!: ICellRendererParams;
  public cellValue: string;
  constructor(
    private subscriptionProductsService: SubscriptionProductsService
  ) {
    // Constructor placeholder
  }

  agInit(params: ICellRendererParams): void {
    this.cellValue = this.getValueToDisplay(params);
    this.params = params;
  }

  refresh(params: ICellRendererParams): boolean {
    this.cellValue = this.getValueToDisplay(params);
    return true;
  }

  /**
   * Get Data value to display in template
   * @param params - ICellRendererParams
   */
  private getValueToDisplay(params: ICellRendererParams): string {
    const rowData: GridRowData = params.data;
    const docTypes: GridHeader[] = params.context.docTypesHeaders();
    const selectedDocs = [];
    docTypes.forEach((doc: GridHeader) => {
      if (rowData[doc.id]) {
        selectedDocs.push(doc.name || doc.id);
      }
    });
    return selectedDocs.join(', ');
  }

  public editDocuments(): void {
    // Edit placeholder
    this.subscriptionProductsService.setIsProductsModalVisible$(true);
    this.subscriptionProductsService.setSingleRowData$(
      this.params.data as GridRowData
    );
    return;
  }
}
